import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";
//import { HttpClient } from "@angular/common/http";



import { BsDropdownModule } from "ngx-bootstrap/dropdown";
//import { ProgressbarModule } from "ngx-bootstrap/progressbar";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { TabsModule } from "ngx-bootstrap/tabs";
//import { PaginationModule } from "ngx-bootstrap/pagination";
import { AlertModule } from "ngx-bootstrap/alert";
//import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { ModalModule } from "ngx-bootstrap/modal";
import { JwBootstrapSwitchNg2Module } from "jw-bootstrap-switch-ng2";
import { PopoverModule } from "ngx-bootstrap/popover";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { IndexComponent } from "./index/index.component";
//import { ProfilepageComponent } from "./examples/profilepage/profilepage.component";
//import { RegisterpageComponent } from "./examples/registerpage/registerpage.component";
import { InstitucionalComponent } from "./examples/institucional/institucional.component";
//import { LandingpageComponent } from "./examples/landingpage/landingpage.component";
import { PrestadoresComponent } from './examples/prestadores/prestadores.component';
import { AfiliadosComponent } from './examples/afiliados/afiliados.component';
import { ServiciosComponent } from './examples/servicios/servicios.component';
import { TelefonosComponent } from './examples/telefonos/telefonos.component';
import { HorariosComponent } from './examples/horarios/horarios.component';
import { HeadComponent } from './head/head.component';
import { CosunComponent } from './examples/cosun/cosun.component';
import { DecomComponent } from './examples/decom/decom.component';
//import { fileURLToPath } from "url";
import { VacunacionAntigripalComponent } from './examples/vacunacion-antigripal/vacunacion-antigripal.component';
import { FormularioEleccionesComponent } from './examples/formulario-elecciones/formulario-elecciones.component';


const routes: Routes = [
  { path: "", component: IndexComponent, pathMatch: "full" },
  { path: "inicio", component: IndexComponent },
  //{ path: "profile", component: ProfilepageComponent },
  //{ path: "sesion", component: RegisterpageComponent },
  { path: "institucional", component: InstitucionalComponent },
  { path: "prestadores", component: PrestadoresComponent },
  { path: "afiliados", component: AfiliadosComponent },
  { path: "servicios", component: ServiciosComponent },
  { path: "telefonos", component: TelefonosComponent },
  { path: "horarios", component: HorariosComponent },
  //{ path: "landing", component: LandingpageComponent },
  { path: "decom", component: DecomComponent },
  { path: 'contacto', component: InstitucionalComponent},
  { path: "#contacto", component: InstitucionalComponent},
  { path: "cobertura", component: ServiciosComponent },
  { path: "#cobertura", component: ServiciosComponent },
  { path: "enfermeria", component: ServiciosComponent },
  { path: "#enfermeria", component: ServiciosComponent },
  { path: "vacunacion-antigripal", component: VacunacionAntigripalComponent },
  { path: "formulario-asamblea", component: FormularioEleccionesComponent },
  { path: "**", component: IndexComponent }
  
  
  
];


@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,    
    RouterModule.forRoot(routes, {
      useHash: true,
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'top',
      scrollOffset: [0, 0],
      
    
    })
  ,
    BsDropdownModule.forRoot(),
    //ProgressbarModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    CollapseModule.forRoot(),
    JwBootstrapSwitchNg2Module,
    TabsModule.forRoot(),
    //PaginationModule.forRoot(),
    AlertModule.forRoot(),
    //BsDatepickerModule.forRoot(),
    CarouselModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [
    IndexComponent,
    //ProfilepageComponent,
    //RegisterpageComponent,
    InstitucionalComponent,
    //LandingpageComponent,
    PrestadoresComponent,
    AfiliadosComponent,
    ServiciosComponent,
    TelefonosComponent,
    HorariosComponent,
    HeadComponent,
    CosunComponent,
    DecomComponent,
    VacunacionAntigripalComponent,
    FormularioEleccionesComponent,
  ],
  exports: [
    IndexComponent,
    //ProfilepageComponent,
    //RegisterpageComponent,
    InstitucionalComponent,
    //LandingpageComponent
  ],
  providers: []
})
export class PagesModule {}
